import React from 'react';
import { useNavigate } from 'react-router-dom';

const Ring = ({ frontImage, linkPath, buttonText }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-16 justify-center items-center md:mb-8 mb-2">
      <div className="w-[200px] h-[200px]">
        <img 
          src={frontImage}
          alt="Ring"
          className="w-full h-full justify-center object-cover rounded-full"
        />
      </div>

      <button
        onClick={() => navigate(linkPath)}
        className="bg-transparent border-2 border-white text-white px-8 py-2 rounded-full hover:bg-white hover:bg-opacity-10 transition-all duration-300"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default Ring;
